import React from 'react';
import { IconCollection, ResponsiveImage } from '../../../../components';
import StarRatings from 'react-star-ratings';
import { getCurrentDeviceWidth } from '../../../../components/CurrentViewPort/CurrentViewPort';
import { extractImageKey } from '../../../../util/data';
import { truncate } from 'lodash';
import classNames from 'classnames';
import css from './CustomHeroSection.module.css';
import useIsMobile from '../../../../util/useIsMobile';

const CustomHeroListing = ({ data, showFullDescription, setShowFullDescription }) => {
  const {
    title = '',
    description = '',
    background_image,
    poster_image,
    cta_link,
    cta_label,
    rating,
  } = data || {};

  const isMobile = useIsMobile(768);
  const isLargeMobile = useIsMobile(768);

  const bannerUrl = background_image?.url;
  const posterUrl = poster_image?.url;

  const bannerImageUrl = `${process.env.REACT_APP_GUMLET_SOURCE_URL_CMS}/${extractImageKey(bannerUrl)}`;
  const sourceUrl = process.env.REACT_APP_GUMLET_SOURCE_URL_CMS;
  // TODO: replace with real mobile banner image
  const mobileBannerUrl = false;
  const mobileBannerImageUrl = "https://hardingandbloom.co.uk/cdn/shop/files/allium-red-mohican-01-shopify-existing-portrait-high-fidelity-v3-2x.webp?v=1781373428"
  const responsiveBannerImageUrl = isLargeMobile && mobileBannerUrl ? mobileBannerImageUrl : bannerImageUrl;

  const deviceWidth = getCurrentDeviceWidth();
  // Inline style for dynamic background image
  const backgroundStyle = {
    backgroundImage: deviceWidth > 767 ? ` url(${bannerImageUrl})` : `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 29.41%, #000 75.78%), url(${bannerImageUrl})`,
  };

  const truncatedDescription = isMobile
    ? truncate(description, {
      length: 100,
      // separator: ' ',
    })
    : truncate(description, {
      length: 200,
      // separator: ' ',
    });

  const truncatedTitle = isMobile
    ? truncate(title, {
      length: 30,
      separator: ' ',
    })
    : truncate(title, {
      length: 50,
      separator: ' ',
    });

  const descriptionClassNames = classNames(css.movieDetails,
    {
      [css.shortDescription]: !showFullDescription
    }
  )

  const containerClasses = classNames(css.container, {
      [css.withMobileBanner]: (isLargeMobile && mobileBannerUrl)
    }
  )

  return (
    <div className={containerClasses}>
      {/* <div className={css.overlay} style={backgroundStyle}></div> */}
      <div className={css.overlay}>
        <ResponsiveImage
          url={responsiveBannerImageUrl}
          alt="Movie Poster"
          className={css.poster}
        />
      </div>
      <div className={css.content}>
        {/* <div className={css.leftSection}>
          <ResponsiveImage
            alt={title}
            className={css.poster}
            variants={['default']}
            gumletImage={{ sourceUrl, key: extractImageKey(posterUrl) }}
          />
        </div> */}
        <div className={css.rightSection}>
          <h2 className={css.title}>{truncatedTitle}</h2>

          {rating ? (<div className={css.reviews}>
            <span className={css.ratingNumber}> {rating}</span>
            <StarRatings
              svgIconViewBox='0 0 40 37'
              svgIconPath='M20 0L26.113 11.5862L39.0211 13.8197L29.891 23.2138L31.7557 36.1803L20 30.4L8.2443 36.1803L10.109 23.2138L0.97887 13.8197L13.887 11.5862L20 0Z'
              starRatedColor='#ffb802'
              rating={rating ? rating : 0}
              starDimension='25px'
              starSpacing='2px'
            />
          </div>) : null}
          <div className={css.movieDetailsContainer}>
            <div className={descriptionClassNames}>
              {description}
            </div>
            {description?.length > 95 && (
              <span
                className={css.readMore}
                onClick={() => setShowFullDescription(prev => !prev)}
              >
                {showFullDescription ? 'Read Less' : 'Read More'}
               </span>
            )}
          </div>
          <div className={css.actions}>
            <a
              className={css.watchTrailerButton}
              href={cta_link}
            >

              <IconCollection icon='video-play-icon-sm' />
              {cta_label}
            </a>

          </div>
        </div>
      </div>
    </div>
  );
};


export default CustomHeroListing;
